import { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { ReportRow } from './ReportRow';
import { LoadingSpinner } from '../Common/LoadingSpinner';

export function SavedReports() {
  const [search, setSearch] = useState('');
  const [reports, setReports] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.listSavedReports(search || undefined)
      .then(r => setReports(r.reports))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <input
          type="text"
          placeholder="Search reports…"
          value={search}
          onChange={e => setSearch(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') load(); }}
          className="flex-1 px-3 py-1.5 text-sm bg-surface border border-border rounded-md focus:outline-none focus:border-accent"
        />
      </div>
      {loading && <LoadingSpinner label="Loading reports…" />}
      {!loading && reports.length === 0 && (
        <div className="text-sm text-text-muted">No saved reports yet.</div>
      )}
      {!loading && reports.length > 0 && (
        <div className="space-y-2">
          {reports.map(r => <ReportRow key={r.id} report={r} onChange={load} />)}
        </div>
      )}
    </div>
  );
}
